import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=9f97b312&scoped=true"
import script from "./CategoryList.vue?vue&type=script&lang=js"
export * from "./CategoryList.vue?vue&type=script&lang=js"
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=9f97b312&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f97b312",
  null
  
)

export default component.exports